"use client";

import { authorizedFetch } from "@/lib/auth/authorized-fetch";

import { useEffect, useState } from "react";
import {
    DEFAULT_PRISM_MODEL_ID,
    PRISM_BUILTIN_SKILLS,
    PRISM_CONNECTORS,
    PRISM_MODELS,
    type PrismCatalog,
} from "@/lib/prism/catalog";

const FALLBACK: PrismCatalog = {
    models: PRISM_MODELS,
    skills: PRISM_BUILTIN_SKILLS,
    connectors: PRISM_CONNECTORS,
    defaultModelId: DEFAULT_PRISM_MODEL_ID,
};

/** Loads the live Prism catalog (models / skills / connectors) once per mount. */
export function usePrismCatalog() {
    const [catalog, setCatalog] = useState<PrismCatalog>(FALLBACK);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        let cancelled = false;
        async function load() {
            try {
                const res = await authorizedFetch("/api/prism/catalog", { credentials: "include" });
                if (res.ok) {
                    const data = (await res.json()) as PrismCatalog;
                    if (!cancelled && data?.models) setCatalog(data);
                }
            } catch {
                /* keep fallback */
            } finally {
                if (!cancelled) setLoaded(true);
            }
        }
        void load();
        return () => {
            cancelled = true;
        };
    }, []);

    return { catalog, loaded };
}
